import React from "react";
import PropTypes from "prop-types";

import lightTheme from "../styles/theme";
import darkTheme from "../styles/new-theme";

export const ThemeContext = React.createContext({});

const ThemeProvider = props => {
  const [theme, setTheme] = React.useState("dark");

  function toggleTheme() {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    window.localStorage.setItem("theme", newTheme);
  }

  React.useEffect(
    () => {
      document.body.className = `${theme}`;
    },
    [theme]
  );

  React.useEffect(
    () => {
      if (typeof window !== "undefined") {
        setTheme(window.localStorage.getItem("theme") || "dark");
      }
    },
    [typeof window !== "undefined"]
  );

  return (
    <ThemeContext.Provider
      value={{
        theme: theme === "dark" ? darkTheme : lightTheme,
        isDark: theme === "dark",
        toggleTheme
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;

ThemeProvider.propTypes = {
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/contexts/ThemeContext.js